<template>
	<section>
		<div class="row field">
			<div class="col-md-12">
				<fieldset>
					<div class="field-title">
						<div class="legend">
							Email de notificação
						</div>
					</div>

					<div class="container-fluid">
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
				                    <label  for="mailto">Enviar para:</label>
				                    <input type="text" v-model="params.mailto" class="form-control">
				                </div>
							</div>

							<div class="col-md-6">
								<div class="form-group">
				                    <label  for="mailcc">
				                    	Com conhecimento para: 
				                    	<small class="atencao link" data-toggle="popover" title="Atenção" data-content="Separar os emails por vírgula e sem espaço.">
				                    		<i class="fas fa-exclamation-triangle"></i>
				                    	</small>
				                    </label>
				                    <input type="text" v-model="params.mailcc" class="form-control">
				                </div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
		</div>

		<div class="row field hidden">
			<div class="col-md-12">
				<fieldset>
					<div class="field-title">
						<div class="legend">
							Dashboard
						</div>
					</div>

					<div class="container-fluid">
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
				                    <label>Atualizar a cada:</label><br>

				                    <div class="form-check-inline">
      									<label class="form-check-label" for="dsbTime20">
        									<input type="radio" v-model="params.dsb_time_refresh" class="form-check-input" value="20">20 Segundos
      									</label>
    								</div>

    								<div class="form-check-inline">
      									<label class="form-check-label" for="dsbTime30">
        									<input type="radio" v-model="params.dsb_time_refresh" class="form-check-input" value="30">30 Segundos
      									</label>
    								</div>

    								<div class="form-check-inline">
      									<label class="form-check-label" for="dsbTime40">
        									<input type="radio" v-model="params.dsb_time_refresh" class="form-check-input" value="40">40 Segundos
      									</label>
    								</div>

    								<div class="form-check-inline">
      									<label class="form-check-label" for="dsbTime50">
        									<input type="radio" v-model="params.dsb_time_refresh" class="form-check-input" value="50">50 Segundos
      									</label>
    								</div>

    								<div class="form-check-inline">
      									<label class="form-check-label" for="dsbTime60">
        									<input type="radio" v-model="params.dsb_time_refresh" class="form-check-input" value="60">60 Segundos
      									</label>
    								</div>
				                </div>
							</div>

							<div class="col-md-6">
								<div class="form-group">
				                    <label>Mostrar:</label><br>

				                    <div class="form-check-inline">
										<label class="form-check-label">
											<input type="checkbox" v-model="params.dsb_ramais" class="form-check-input">Status ramais
										</label>
									</div>

									<div class="form-check-inline">
										<label class="form-check-label">
											<input type="checkbox" v-model="params.dsb_chart_den" class="form-check-input">Denúncias por hora
										</label>
									</div>

									<div class="form-check-inline">
										<label class="form-check-label">
											<input type="checkbox" v-model="params.dsb_chart_in" class="form-check-input">Entradas por hora
										</label>
									</div>

									<div class="form-check-inline">
										<label class="form-check-label">
											<input type="checkbox" v-model="params.dsb_chart_out" class="form-check-input">Saídas por hora
										</label>
									</div>
				                </div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
		</div>

		<div class="row field">
			<div class="col-md-12">
				<fieldset>
					<div class="field-title">
						<div class="legend">
							Imagens
						</div>
					</div>

					<div class="container-fluid">
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
				                    <label  for="mailto">Tela de login:</label>
				                    <img :src="params.bg_login" @click="show_image(params.bg_login, 'bg_login')" class="img-thumbnail pointer">
				                    <input type="file" class="hidden">
				                </div>
							</div>

							<div class="col-md-6">
								<div class="form-group">
				                    <label  for="mailcc">Logotipo:</label>
				                    <img :src="params.logotipo" @click="show_image(params.logotipo, 'logotipo')" class="img-thumbnail pointer">
				                    <input type="file" class="hidden">
				                </div>
							</div>
						</div>
					</div>
				</fieldset>
			</div>
		</div>

		<div class="d-flex flex-row-reverse bd-highlight mb-3">
			<button @click="save" class="btn btn-sm btn-success">Salvar</button>
		</div>
		
		<imagem :img="modal_image" :inputable="true" :input="modal_image_input" ref="showIMG" @change="update_image" />
	</section>
</template>

<script>
	import imagem from "@/components/Modal/Image.vue"
	import api    from "@/mixins/api.js"
	import alert       from '@/components/Tools/alert'

	export default {
		name: "System_config",
		components: { imagem,alert },
		mixins: [api],

		data() { 
			return {
				params: null,
				modal_image: null,
				modal_image_input: "",
			}
		},

		created() {
			this.params = this.config;
		},

		computed: {
			config() { return this.$store.state.config }
		},

		methods: {
			async save() {
				const response = await this.PUT("Config", this.params);

				if ( response.status == 'success' ){
					this.$store.dispatch("update_config", response.data );
				}
				this.$emit('alert', response);
			},

			show_image(img, input) {
				this.modal_image = img;
				this.modal_image_input = input;
				this.$refs.showIMG.clear();
				$("#modal-image").modal();
			},

			update_image(payload) {
				if ( payload.input == 'logotipo' ){
					this.params.logotipo = payload.img;
				}

				if ( payload.input == 'bg_login' ){
					this.params.bg_login = payload.img;
				}
			}
		}
	}
</script>

<style>
	.img-thumbnail {
		width: 100%;
		height: 280px;
	}
</style>